module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'urlap'),
      expression: "nezet.tipus == 'urlap'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "disabled": "",
      "label": "Név"
    },
    model: {
      value: (_vm.form.values.nev),
      callback: function($$v) {
        _vm.form.values.nev = $$v
      },
      expression: "form.values.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "neptunkod",
      "name": "neptunkod",
      "disabled": "",
      "label": "Neptun azonosító"
    },
    model: {
      value: (_vm.form.values.neptunkod),
      callback: function($$v) {
        _vm.form.values.neptunkod = $$v
      },
      expression: "form.values.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiHely",
      "name": "szuletesiHely",
      "disabled": "",
      "label": "Születési hely"
    },
    model: {
      value: (_vm.form.values.szuletesiHely),
      callback: function($$v) {
        _vm.form.values.szuletesiHely = $$v
      },
      expression: "form.values.szuletesiHely"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiIdo",
      "name": "szuletesiIdo",
      "disabled": "",
      "label": "Születési idő"
    },
    model: {
      value: (_vm.form.values.szuletesiIdo),
      callback: function($$v) {
        _vm.form.values.szuletesiIdo = $$v
      },
      expression: "form.values.szuletesiIdo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "anyjaNeve",
      "name": "anyjaNeve",
      "disabled": "",
      "label": "Anyja neve"
    },
    model: {
      value: (_vm.form.values.anyjaNeve),
      callback: function($$v) {
        _vm.form.values.anyjaNeve = $$v
      },
      expression: "form.values.anyjaNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "telefonszam",
      "name": "telefonszam",
      "disabled": "",
      "label": "Telefonszám"
    },
    model: {
      value: (_vm.form.values.telefonszam),
      callback: function($$v) {
        _vm.form.values.telefonszam = $$v
      },
      expression: "form.values.telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "emailCim",
      "name": "emailCim",
      "disabled": "",
      "label": "E-mail cím"
    },
    model: {
      value: (_vm.form.values.emailCim),
      callback: function($$v) {
        _vm.form.values.emailCim = $$v
      },
      expression: "form.values.emailCim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Képzések",
      "id": "kepzesKodja",
      "options": _vm.kepzesek
    },
    on: {
      "onChange": _vm.kepzesValt
    },
    model: {
      value: (_vm.form.values.kivalasztottKepzesKodja),
      callback: function($$v) {
        _vm.form.values.kivalasztottKepzesKodja = $$v
      },
      expression: "form.values.kivalasztottKepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kar",
      "name": "kar",
      "disabled": "",
      "label": "Kar neve"
    },
    model: {
      value: (_vm.form.values.kar),
      callback: function($$v) {
        _vm.form.values.kar = $$v
      },
      expression: "form.values.kar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tagozat",
      "name": "tagozat",
      "disabled": "",
      "label": "Tagozat"
    },
    model: {
      value: (_vm.form.values.tagozat),
      callback: function($$v) {
        _vm.form.values.tagozat = $$v
      },
      expression: "form.values.tagozat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesNeve",
      "name": "kepzesNeve",
      "disabled": "",
      "label": "Képzés"
    },
    model: {
      value: (_vm.form.values.kepzesNeve),
      callback: function($$v) {
        _vm.form.values.kepzesNeve = $$v
      },
      expression: "form.values.kepzesNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesKodja",
      "name": "kepzesKodja",
      "disabled": "",
      "label": "Képzés kódja"
    },
    model: {
      value: (_vm.form.values.kepzesKodja),
      callback: function($$v) {
        _vm.form.values.kepzesKodja = $$v
      },
      expression: "form.values.kepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesSzintje",
      "name": "kepzesSzintje",
      "disabled": "",
      "label": "Képzés szintje"
    },
    model: {
      value: (_vm.form.values.kepzesSzintje),
      callback: function($$v) {
        _vm.form.values.kepzesSzintje = $$v
      },
      expression: "form.values.kepzesSzintje"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgatoiStatusz",
      "name": "hallgatoiStatusz",
      "disabled": "",
      "label": "Hallgatói státusz"
    },
    model: {
      value: (_vm.form.values.hallgatoiStatusz),
      callback: function($$v) {
        _vm.form.values.hallgatoiStatusz = $$v
      },
      expression: "form.values.hallgatoiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesHelye",
      "name": "kepzesHelye",
      "disabled": "",
      "label": "Képzés helye"
    },
    model: {
      value: (_vm.form.values.kepzesHelye),
      callback: function($$v) {
        _vm.form.values.kepzesHelye = $$v
      },
      expression: "form.values.kepzesHelye"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "penzugyiStatusz",
      "name": "penzugyiStatusz",
      "disabled": "",
      "label": "Pénzügyi státusz"
    },
    model: {
      value: (_vm.form.values.penzugyiStatusz),
      callback: function($$v) {
        _vm.form.values.penzugyiStatusz = $$v
      },
      expression: "form.values.penzugyiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "osztondijindex",
      "name": "osztondijindex",
      "disabled": "",
      "label": "Ösztöndíjindex"
    },
    model: {
      value: (_vm.form.values.osztondijindex),
      callback: function($$v) {
        _vm.form.values.osztondijindex = $$v
      },
      expression: "form.values.osztondijindex"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.values.rendkivuliSzocialisTamogatasTanevben),
      expression: "form.values.rendkivuliSzocialisTamogatasTanevben"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "rendkivuliSzocialisTamogatasTanevben",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.values.rendkivuliSzocialisTamogatasTanevben) ? _vm._i(_vm.form.values.rendkivuliSzocialisTamogatasTanevben, null) > -1 : _vm._q(_vm.form.values.rendkivuliSzocialisTamogatasTanevben, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.values.rendkivuliSzocialisTamogatasTanevben,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.values.rendkivuliSzocialisTamogatasTanevben = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.values.rendkivuliSzocialisTamogatasTanevben = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.values.rendkivuliSzocialisTamogatasTanevben = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'rendkivuliSzocialisTamogatasTanevben') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.form.values.rendkivuliSzocialisTamogatasTanevben) == 1 ? true : false),
      expression: "parseInt(form.values.rendkivuliSzocialisTamogatasTanevben) == 1 ? true : false"
    }],
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "datepicker": true,
      "errors": _vm.errors,
      "id": "rendkivuliSzocialisTamogatasTanevbenIgenylesDatum",
      "name": "rendkivuliSzocialisTamogatasTanevbenIgenylesDatum",
      "label": "Igénylés dátuma"
    },
    model: {
      value: (_vm.form.values.rendkivuliSzocialisTamogatasTanevbenIgenylesDatum),
      callback: function($$v) {
        _vm.form.values.rendkivuliSzocialisTamogatasTanevbenIgenylesDatum = $$v
      },
      expression: "form.values.rendkivuliSzocialisTamogatasTanevbenIgenylesDatum"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "tamogatasok"
    }
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.kategoriak), function(kategoria) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding-bottom": "20px"
      }
    }, [_c('h6', [_vm._v("\n            " + _vm._s(kategoria.megnevezes) + "\n          ")]), _vm._v(" "), _vm._l((kategoria.tamogatasok), function(tamogatas, i) {
      return _c('div', {
        staticClass: "form-checkbox-wrapper"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.form.values.tamogatasok),
          expression: "form.values.tamogatasok"
        }],
        attrs: {
          "multiple": "",
          "id": 'tamogatas_' + tamogatas.id,
          "type": "checkbox"
        },
        domProps: {
          "value": tamogatas.id,
          "checked": Array.isArray(_vm.form.values.tamogatasok) ? _vm._i(_vm.form.values.tamogatasok, tamogatas.id) > -1 : (_vm.form.values.tamogatasok)
        },
        on: {
          "__c": function($event) {
            var $$a = _vm.form.values.tamogatasok,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = tamogatas.id,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (_vm.form.values.tamogatasok = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.form.values.tamogatasok = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.form.values.tamogatasok = $$c
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": 'tamogatas_' + tamogatas.id
        }
      }, [_c('div', {
        staticClass: "icon"
      }), _vm._v("\n              " + _vm._s(tamogatas.megnevezes) + "\n            ")])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 form-group"
  }, _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'tamogatasok') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Feltöltendő dokumentumok\n          ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('UploadHandler', {
    attrs: {
      "max_uploaded_files": _vm.igazolasokMaxFeltolthetoFajl,
      "msg": "abc",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "igazolasok",
      "label": "A (támogatásra okot adó körülmény) igazolásához szükséges (fentebbi táblázat alapján)",
      "name": "igazolasok",
      "loaded_files": _vm.form.values.igazolasok
    },
    on: {
      "change": function (value) {
        _vm.form.values.igazolasok = value;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Indoklás\n          ")]), _vm._v(" "), _c('textareabox', {
    attrs: {
      "errors": _vm.errors,
      "id": "indoklas",
      "autogrow": true,
      "label": "Indoklás",
      "name": "indoklas"
    },
    model: {
      value: (_vm.form.values.indoklas),
      callback: function($$v) {
        _vm.form.values.indoklas = $$v
      },
      expression: "form.values.indoklas"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Igényelt összeg (HUF)\n          ")]), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "id": "igenyeltOsszeg",
      "label": "Igényelt összeg",
      "name": "igenyeltOsszeg"
    },
    model: {
      value: (_vm.form.values.igenyeltOsszeg),
      callback: function($$v) {
        _vm.form.values.igenyeltOsszeg = $$v
      },
      expression: "form.values.igenyeltOsszeg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.values.nyilatkozatElfogadas),
      expression: "form.values.nyilatkozatElfogadas"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "nyilatkozatElfogadas",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.values.nyilatkozatElfogadas) ? _vm._i(_vm.form.values.nyilatkozatElfogadas, null) > -1 : _vm._q(_vm.form.values.nyilatkozatElfogadas, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.values.nyilatkozatElfogadas,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.values.nyilatkozatElfogadas = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.values.nyilatkozatElfogadas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.values.nyilatkozatElfogadas = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozatElfogadas') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveConfirm(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'info'),
      expression: "nezet.tipus == 'info'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Rendkívüli szociális ösztöndíj\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.nezet.tartalom)
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Rendkívüli szociális ösztöndíj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Amennyiben hibát talál "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("személyes")]), _vm._v(" vagy "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("képzési adataiban")]), _vm._v(", kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Személyes adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Képzési adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Korábbi igénylés\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "rendkivuliSzocialisTamogatasTanevben"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                Igényelt már rendkívüli szociális támogatást ebben a tanévben?\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Támogatásra okot adó körülmények\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Pályázathoz szükséges dokumentumokhoz az alábbi linken olvashatsz információkat:\n            "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://student.sze.hu/downloadmanager/download/nohtml/1/id/48621/m/16718"
    }
  }, [_vm._v("https://student.sze.hu/downloadmanager/download/nohtml/1/id/48621/m/16718")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Hallgatói nyiltakozat\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozatElfogadas"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                A pályázat benyújtásával büntetőjogi felelősségem teljes tudatában kijelentem, hogy hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem, mely a hallgatói jogviszony fegyelmi úton történő megszüntetését is eredményezheti. Továbbá hozzájárulok ahhoz, hogy adataimat a Széchenyi István Egyetem Hallgatói Önkormányzata nevében eljáró személyek a pályázat elbírálásával összefüggésben, a TJSZ-ben rögzített feltételeknek, illetve a személyi adatok védelméről és a közérdekű adatok nyilvánosságáról szóló 1992. évi LXIII. törvénynek megfelelően kezelje.\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7112bf3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/rendkivuli_szocialis_osztondij.vue
// module id = 387
// module chunks = 0